import { IDriverListRequest, IPredecessorShipmentInputProps } from '../../schemas/carrierAssign/CarrierAssign.schema';

export class DriverList implements IDriverListRequest {
  carrierId?: string;
  roleName?: string;
  size?: string;
  page?: string;
  sort?: string;

  getRequestPayload() {
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function") input[key] = value;
    }
    return {
      query: {
        getMembers: {
          __args: { 
            input: {
              carrierId: this.carrierId,
              roleName: this.roleName,
              size: this.size,
              page: this.page,
              sort: this.sort
            },
           },
          upn: true,
          firstName: true,
          lastName: true,
          companyName: true,
          email: true,
          liablePartyId: false,
          liablePartyName: false,
          lastSelectedCustomer: false,
          lastSelectedCarrier: false,
          carrier: true,
          carrierId: true,
          tractorNumber: true,
          internalUser: false,
          customer: false,
          registered: true,
          mobileNumber: true,
          address: {
            addressLine1: true,
            addressLine2: true,
            addressType: true,
            city: true,
            state: true,
            postalCode: true
          },
          phoneNumberDetails :{
            number: true,
            phoneNumberType: true,
            },
          userLastLogin: true,
          userApplicationDetails: {
            roles: {
              roleId: true,
              roleName: true
            }
          },
        }
      }
    };
  }
}

export class PredecessorShipment implements IPredecessorShipmentInputProps {
  shipmentId!: string;
  driverId!: string;
  assignSource!: string;

  getPredecessorRequestPayload() {
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function") input[key] = value;
    }
    return {
      query: {
        predecessorShipmentId: {
          __args: {
            ...input
          },
        }
      }
    }
  }
}
